import React from 'react'
import {AttributionControl, MapContainer, Marker, Polygon, TileLayer} from 'react-leaflet'
import getLeaftletProvider from '@helpers/maps/getLeafletProvider'
import getFileURL from '@helpers/misc/getFileURL'
import L from 'leaflet'
import {GestureHandling} from 'leaflet-gesture-handling'

import Props from '../MapInterface'

import 'leaflet/dist/leaflet.css'
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css'

L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling)

export default function Leaflet({iconURL, color, center, getStores, getPoints}: Props) {
  const renderAreas = () => {
    const options = {
      weight: 1,
      fillOpacity: 0.2,
      fillColor: color,
      color
    }
    return getStores().map(store => {
      return (
        <React.Fragment key={`store_${store._id}`}>
          {store.zones.map(zone => (
            <Polygon
              positions={zone.deliveryLimits}
              key={`polygon_${zone._id}`}
              pathOptions={options}
            />
          ))}
        </React.Fragment>
      )
    })
  }

  const renderStores = () => {
    return getStores().map(store => {
      const iconSize = 25

      const icon = new L.Icon({
        iconUrl: iconURL ? getFileURL(iconURL) : '/images/store-in-map.svg',
        iconSize: [iconSize, iconSize],
        iconAnchor: [iconSize / 2, iconSize / 2]
      })
      return <Marker icon={icon} position={store.address.location} key={`marker_${store._id}`} />
    })
  }

  const setCenter = map => {
    if (!map) return
    const points = getPoints()
    const bounds = new L.LatLngBounds(null)
    for (const point of points) {
      bounds.extend(point)
    }
    map.fitBounds(bounds)
  }

  return (
    <MapContainer
      center={[center.lat, center.lng]}
      zoom={15}
      scrollWheelZoom={false}
      ref={setCenter}
      // 👇️ Estos 2 comentarios permiten ignorar que gestureHandling no es una opción nativa de MapContainer (añadida por leaflet-gesture-handling)
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      gestureHandling={true}
      attributionControl={false}
      style={{width: '100%', height: '400px'}}>
      <TileLayer {...getLeaftletProvider()} />
      <AttributionControl prefix={false} />

      {renderAreas()}
      {renderStores()}
    </MapContainer>
  )
}
